<template>
	<el-drawer title="应用到其他组别" :visible.sync="dialogVisible" :modal-append-to-body="false" size="50%" direction="rtl" :wrapperClosable="false" >
		<div class="basis-page-cls apply-group">
			<section class="basis-cls_filter">
				<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" pageNumber="pageNum" />
			</section>
			<div class="basis-cls_table">
					<el-table :data="data" @selection-change="handleSelectionChange" ref="table">
						<el-table-column type="selection" width="55" align="center" :selectable="checkSelectable"></el-table-column>
						<el-table-column prop="skillId" label="技能组ID" align="center"></el-table-column>
						<el-table-column prop="skillName" label="技能组名称" align="center"></el-table-column>
					</el-table>
					<el-pagination :page-size="listQuery.pageSize" @current-change="currentChange" :current-page="listQuery.pageNum"
					 style="padding-top: 20px" :total="total" layout="prev,pager,next,total"></el-pagination>
			 <div class="apply-group-footer">
				<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
				<el-button type="primary" @click="onApplpy" size="mini" :loading="loading">{{ loading ? '提交中 ...' : '应 用' }}</el-button>
			 </div>
			</div>
		</div>
	</el-drawer>

</template>

<script>
	import { mapGetters } from "vuex";
	export default {
		props:['details','apiUrl'],
		computed:{
			 ...mapGetters([
				'subBrandList',
			])
		},
		data() {
			return {
				dialogVisible:false,
				filterHeader:[
					{ label: '品牌', model: 'childBrand', type: 'select', default: '', list: [] },
					{ label: '技能组', model: 'skillName', type: 'input', default: '', placeholder: '请输入技能组名称' },
				],
				listQuery: {
					brand:this.$store.state.user.brandId,
					skillName:'',
					pageNum:1,
					pageSize:10,
					childBrand:''
				},
				loading:false,
				data: [],
				total: 1,
				disabled_data:[],
				multipleSelectionAll: [], // 所有选中的数据包含跨页数据
				multipleSelection: [], // 当前页选中的数据
				idKey: "skillId", // 标识列表数据中每一行的唯一键的名称(需要按自己的数据改一下)
			}
		},
		methods: {
			filterSearch(query) {
				this.listQuery = Object.assign(this.listQuery, query);
			    this.getData();
			},
			onApplpy(){
				this.changePageCoreRecordData();
				if (this.multipleSelectionAll.length <= 0) {
					this.$message({
						message: "无勾选数据！",
						type: "warning"
					});
					return;
				}
				let result = [];
				this.loading = true
				this.multipleSelectionAll.map(item => {
					result.push({
						targetId:item.skillId,
						targetBrand:item.childBrand
					})
				})
				this.$api.applySystemSkillGroup(`${this.apiUrl}${this.details.skillId}`,result).then(res => {
					this.loading = false
					if(res.errcode == 0) {
						this.$message.success('应用成功')
						this.dialogVisible = false
						this.$emit('getList')
					}
				}).catch(err => {
					this.loading = false
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			openApply(){
				let result = [];
				this.dialogVisible = true
				this.multipleSelectionAll = [];
				this.multipleSelection = []
				this.$nextTick(()=>{
					result.push({
						skillId:this.details.skillId
					})
					this.disabled_data = result
					this.$refs.table.clearSelection();
					this.getData()
				})
				
			},
			async getData(){
				let params = {
					data:{
						brand: this.listQuery.brand,
						childBrand: this.listQuery.childBrand,
						skillName: this.listQuery.skillName,
					},
					pageNum:this.listQuery.pageNum,
					pageSize:this.listQuery.pageSize,
				}
				await this.$api.getSystemSkillGroup(params).then(res => {
					this.loading = false
					if(res.errcode == 0) {
						this.data = this.setDisabledLists(res.list);
						this.total = res.total
							setTimeout(() => {
								this.setSelectRow();
							}, 20);
					}
				})
			},
			onSearch(){
				
			},
			currentChange(val){
				this.listQuery.pageNum = val
				this.changePageCoreRecordData();
				this.getData()
			},
			// 设置当前数据不能选中
			checkSelectable(row) {
				if (row.dataType && row.dataType == "不可操作") {
					return false;
				}
				return true;
			},
			setDisabledLists(data){
				data.filter(item => {
					this.disabled_data.some(_item => {
						if (item.skillId == _item.skillId) {
							item.dataType = "不可操作";
						}
					});
				});
				return data
			},
			//记忆选择核心方法 
			changePageCoreRecordData(){
				// 标识当前行的唯一键的名称
				let idKey = this.idKey;
				let that = this;
				// 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
				if (this.multipleSelectionAll.length <= 0) {
					this.multipleSelectionAll = this.multipleSelection;
					return;
				}
				// 总选择里面的key集合
				let selectAllIds = [];
				this.multipleSelectionAll.forEach(row => {
					selectAllIds.push(row[idKey]);
				});
				let selectIds = [];
				// 获取当前页选中的id
				this.multipleSelection.forEach(row => {
					selectIds.push(row[idKey]);
					// 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
					if (selectAllIds.indexOf(row[idKey]) < 0) {
						that.multipleSelectionAll.push(row);
					}
				});
				let noSelectIds = [];
				// 得到当前页没有选中的id
				this.data.forEach(row => {
					if (selectIds.indexOf(row[idKey]) < 0) {
						noSelectIds.push(row[idKey]);
					}
				});
				noSelectIds.forEach(id => {
					if (selectAllIds.indexOf(id) >= 0) {
						for (let i = 0; i < that.multipleSelectionAll.length; i++) {
							if (that.multipleSelectionAll[i][idKey] == id) {
								// 如果总选择中有未被选中的，那么就删除这条
								that.multipleSelectionAll.splice(i, 1);
								i --
								break;
							}
						}
					}
				});
			},
			// 设置选中的方法
			setSelectRow() {
				if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
					return;
				}
				// 标识当前行的唯一键的名称
				let idKey = this.idKey;
				let selectAllIds = [];
			
				this.multipleSelectionAll.forEach(row => {
					selectAllIds.push(row[idKey]);
				});
				this.$refs.table.clearSelection();
				for (var i = 0; i < this.data.length; i++) {
					if (selectAllIds.indexOf(this.data[i][idKey]) >= 0) {
						// 设置选中，记住table组件需要使用ref="table"
						this.$refs.table.toggleRowSelection(this.data[i], true);
					}
				}
			}
		},
		async created() {
			this.filterHeader[0]['list'] = await this.subBrandList;
		}
	}
</script>

<style lang="scss">
	.apply-group {
		padding: 20px;
		position: relative;
		.el-table .cell{
			height: 40px;
			line-height: 40px;
		}
	}
	.apply-group-footer {
		text-align: right;
		padding: 20px;
	}
</style>
